module.exports = __webpack_public_path__ + "ClientApp/content/qualityOfLife/dog_belly.svg";